import { HistoryListProps } from "@husky-x/history-list";

export const HistoryMockDk: HistoryListProps  = {
	data: [
		{
			year: 1915,
			description: 'LA Jackson etablerer London Rubber Company og sælger importerede kondomer og udstyr til barbersaloner',
		},
		{
			year: 1929,
			description: 'The London Rubber Company (LRC) får Durex-mærket registreret',
		},
		{
			year: "1950'erne",
			description: 'Durex lancerer sit første fugtede kondom',
		},
		{
			year: 1953,
			description: 'Durex er det første mærke, der udvikler og bruger elektronisk testning',
		},
		{
			year: "1960'erne",
			description: 'Durex lancerer det første anatomisk formede kondom',
		},
		{
			year: "1970'erne",
			description: 'Durex er det første kondommærke i verden, der reklamerer i mange lande',
		},
		{
			year: "1990'erne",
			description: 'Durex er det første kondommærke, der indfører et globalt "kvalitetsstempel" som standard',
		},
		{
			year: 1995,
			description: 'Durex lancerer en række farverige og smagstilsatte kondomer',
		},
		{
			year: 1996,
			description: 'Durex er det første kondommærke, der etablerer en hjemmeside. Vi har nu 42 forskellige hjemmesider for de lande, hvor vi er repræsenteret',
		},
		{
			year: 1997,
			description: 'Durex lancerer latexfri kondomer. Der anvendes et nyt mere allergivenligt materiale til det nye produkt kaldet Syntetisk polyurethan. Materialet er udviklet af Durex, og er blødere og mere elastisk end naturgummilatex',
		},
		{
			year: 1998,
			description: 'Durex er det første kondommærke, der gennemfører og offentliggører en global undersøgelse af seksuel velvære',
		},
		{
			year: 2001,
			description: 'Durex introducerer Pleasuremax. Dette gør Durex til det første kondommærke, der markedsfører et kondom, der både har riller og knopper for at stimulere begge parter',
		},
		{
			year: 2003,
			description: 'Durex lancerer et spændende sortiment af Play glidecremer',
		},
		{
			year: 2005,
			description: 'Durex Network lancerer Face of Global Sex rapporter, der undersøger aspekter af seksuel adfærd, og som udarbejdes som information til embedsmænd og politikere',
		},
		{
			year: 2008,
			description: 'For at fremme sikker sex blandt unge mennesker, opmuntrer Durex unge mennesker mellem 16 og 24 år til at udarbejde en unik plakat om seksuel sundhed - en plakat med unge for unge',
		},
		{
			year: 2009,
			description: 'Durex bliver 80 år!',
		},
		{
			year: 2010,
			description: 'Durex støtter initiativet "Condomize!" fra FNs Befolkningsfond ved den Internationale AIDS konference i Wien med en donation på 220.000 kondomer.',
		},
		{
			year: 2010,
			description: 'Durex erhverves af Reckitt Benckiser.',
		},
		{
			year: 2010,
			description: 'Durex lancerer Performax Intense, et kondom designet til klimaks for begge parter på samme tid. Med et indvendigt lag, der indeholder 5 % benzocain, og en stimulerende struktur, bliver det muligt at dyrke mere intens sex i længere tid.',
		},
		{
			year: 2019,
			description: 'Durex bliver 90 år!',
		},
	]
}